var _title, _title2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 32 32"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Copy")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M6.667 20h-1.333c-0.707 0-1.386-0.281-1.886-0.781s-0.781-1.178-0.781-1.886v-12c0-0.707 0.281-1.386 0.781-1.886s1.178-0.781 1.886-0.781h12c0.707 0 1.386 0.281 1.886 0.781s0.781 1.178 0.781 1.886v1.333M14.667 12h12c1.473 0 2.667 1.194 2.667 2.667v12c0 1.473-1.194 2.667-2.667 2.667h-12c-1.473 0-2.667-1.194-2.667-2.667v-12c0-1.473 1.194-2.667 2.667-2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Close")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M32 3.2l-3.2-3.2-12.8 12.8-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.538bb26b04526535d7088b6053724dd4.svg";
export { ForwardRef as ReactComponent };